"use client";

import { usePathname } from "next/navigation";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

export default function MarketingLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const pathname = usePathname();
  const isDashboard = pathname.startsWith("/dashboard");

  return (
    <>
      <Header />

      {/* ⬇️ فقط این بخش تغییر کرده */}
      <main className={isDashboard ? "bg-transparent p-0 m-0" : "bg-white pt-16"}>
        {children}
      </main>

      {!isDashboard && <Footer />}
    </>
  );
}
